<template>
    <div id="flashContent">
        <object id="G12EHLSPlayer20" classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000"
                align="middle" width="720"
                height="540">
            <param name="movie" value="/styles/G12EHLSPlayer20.swf?v=1"/>
            <param name="bgcolor" value="#333"/>
            <param name="wmode" value="transparent"/>
            <param name="allowScriptAccess" value="always"/>
            <param name="allowFullScreen" value="true"/>
            <param name="FlashVars"/>
            <embed
                    id="G12EHLSPlayer20em"
                    allowscriptaccess="always"
                    wmode="transparent"
                    src="/styles/G12EHLSPlayer20.swf?v=1"
                    allowFullScreen="true"
                    type="application/x-shockwave-flash"
                    width="720" height="540"/>
        </object>
    </div>
</template>

<script>
  import { getRscVideo } from '@/api/player';
  import { $Cookies } from '@/utils';

  export default {
    name: 'FlashPlayer',
    props: {
      rscId: {
        type: String,
        required: true
      },
      timeStamp: {
        type: Object,
        required: true
      },
      orderNum: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        videoPath: '',
        Player: null
      };
    },
    watch: {
      timeStamp: async function () {
        await this.getVideoPath(true);
      }
    },
    mounted () {
      const me = this;
      this.$nextTick(() => {
        me.getPlayer();
        window.nextVideo = me.nextPlay;
        window.lastVideo = me.prevPlay;
        window.mediaPlayComplete = me.finishPlay;
        me.getVideoPath();
      });
    },
    methods: {
      async getVideoPath () {
        const uid = $Cookies.get('uid') || '0';
        await getRscVideo({
          rscID: this.rscId,
          userNo: Number(uid)
        }).then(data => {
          if (data.success) {
            const { url } = data.result;
            let playRegion = `${ this.timeStamp.startTime }-${ this.timeStamp.endTime }`;
            this.Player.setPlay(url, playRegion);
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      getPlayer () {
        if (window.navigator.appName.indexOf('Microsoft') !== -1) {
          this.Player = window[ 'G12EHLSPlayer20' ];
        } else {
          this.Player = document.embeds[ 'G12EHLSPlayer20em' ];
        }
      },
      nextPlay () {
        this.$emit('nextPlay', this.orderNum);
      },
      prevPlay () {
        this.$emit('prevPlay', this.orderNum);
      },
      finishPlay () {
        this.$emit('finishPlay', this.orderNum);
      }
    }
  };
</script>

<style lang="scss">
    #flashContent {
        width: 100%;
        height: 100%;
        margin: 0 !important;
    }
</style>
